import {Component, OnInit, Input, EventEmitter, Output, OnChanges, SimpleChanges} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ProjectDialogComponent} from '@common-components/project-dialog/project-dialog.component';
import {ConstantsService} from "@app/services/constants/constants.service";
import {Projects} from "@app/interfaces/projects";
import {ProjectsService} from "@components/projects/projects.service";
import {BackendResponse} from "@app/interfaces/backendResponse";
import {ToastrService} from "ngx-toastr";
import {FormGroup} from "@angular/forms";

@Component({
    selector: 'app-select-project',
    templateUrl: './select-project.component.html',
    styleUrls: ['./select-project.component.css']
})
export class SelectProjectComponent implements OnInit, OnChanges {
    @Input() data: { name: string, _id: any };
    @Input() isDisabled: boolean;
    @Input() projects: Projects[];
    @Input() myForm: FormGroup;

    @Output() outputToParent = new EventEmitter<any>();


    filteredProjects = [];

    addButtonDisabled = false;
    isSelected: boolean = false;

    buttonText = 'Projekat';
    searchText = '';


    constructor(public dialog: MatDialog,
                private constantsService: ConstantsService,
                private projectsService: ProjectsService,
                private toastr: ToastrService) {
    }

    ngOnInit() {
        this.filteredProjects = this.projects;

        // samo admin moze da dodaje novi projekat
        this.addButtonDisabled = (this.constantsService.admins.indexOf(this.constantsService.getLoggedInUserId()) == -1);

        if (this.data) {
            this.buttonText = this.data.name;
            this.isSelected = true;
        } else {
            this.searchText = '';
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.projects) {
            this.filteredProjects = changes.projects.currentValue;
        }
    }

    setProject(project) {
        this.outputToParent.emit(project);
        this.searchText = '';
        if (project === null) {
            this.isSelected = false;
            this.buttonText = 'Projekat';
        } else {
            this.isSelected = true;
        }

    }

    addNewProjectDialog() {
        this.dialog.open(ProjectDialogComponent, {
            disableClose: true,
            height: '31%'
        }).afterClosed().subscribe(() => {
            this.projectsService.getProjects().subscribe((response: BackendResponse) => {
                if (response.type === 'success') {
                    this.projects = response.data;
                } else {
                    this.toastr.error('Došlo je do greške prilikom izvlačenja projekata.');
                }
            });
        });
    }

    filterProjects(event) {
        if (event.key !== '') {
            this.filteredProjects = this.projects.filter(x => x.name.toLowerCase().includes(this.searchText.toLowerCase()));
        } else {
            this.filteredProjects = this.projects;
        }
    }

    getProjects() {
        this.projectsService.getProjects().subscribe((response: BackendResponse) => {
            if (response.type === 'success') {
                this.projects = response.data;
                this.filteredProjects = this.projects;
            }
        });
    }
}
